function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTollDollar = function SvgTollDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 96 960 960"
  }, props), /*#__PURE__*/React.createElement("circle", {
    cx: 654.31,
    cy: 728.639,
    r: 232.522,
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 48,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.247 174.472 48.327 355.214M194.056 175.103l-86.064 796.71",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 48,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.305 192.52.132 163.04M338.305 455.74l.132 163.04",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 44,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m657.177 542.357.017 40.212M658.598 870.665l.07 42.484",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 48,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.305 731.382.12 149.45",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 43.9994,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.411 623.884c-14.47-16.73-36.415-35.035-65.873-35.676-45.732-.994-70.376 21.669-70.767 56.445-.866 77.092 148.25 75.893 148.222 165.686-.012 39.4-53.63 52.43-83.814 51.957-36.238-.568-65.603-20.787-90.654-59.177",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 43.9287,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }));
};
export default SvgTollDollar;